export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";